TrelloModel = require 'app/scripts/models/internal/trello-model'
_ = require 'underscore'

class ModelWithPreferences extends TrelloModel

  prefNames: []

  constructor: ->
    super
    @_initSubEventsOn 'prefs'
    return

  toJSON: (opts = {}) ->
    data = super

    # Converts a deep object level into a flat mapping. For example:
    # prefs:
    #   foo: bar
    #   baz:
    #    aaa: 1
    #    bbb: 2
    #
    # foo = bar
    # baz_aaa = 1
    # baz_bbb = 2
    #
    getDeepPrefs = (prefList, obj, prefix) =>
      for preference in prefList
        key = if prefix then "#{ prefix }_#{ preference }" else preference
        value = obj?[preference] ? @getPref(preference)
        if _.isObject(value) && !_.isArray(value)
          getDeepPrefs(_.keys(value), value, key)
        else
          data[key] = value
          data["#{ key }_#{ value }"] = true

    if opts.prefs
      getDeepPrefs(@prefNames)

    data

  getPref: (name) ->
    @get('prefs')?[name]

  setPref: (name, value, next) ->
    @update "prefs/#{ name }", value, next

  set: (attrs, options) ->
    attrs = _.clone(attrs)
    if attrs.prefs?
      # Take care of some problems with the notifications; they're sending the values from the DB, which don't
      # actually match what we get from the API
      prefs = attrs.prefs
      for key, value of prefs
        if value == 'none'
          value = 'disabled'
        if value == 'owners'
          value = 'admins'
        prefs[key] = value

    super

module.exports = ModelWithPreferences
